module.exports = ContactCtrl;

// @ngInject
function ContactCtrl($state, localStorageService, Alert, $anchorScroll, deviceDetector) {
  try {
    const vm = this;
    vm.name = 'ContactCtrl';

    vm.deviceInfo = deviceDetector;
    delete vm.deviceInfo.raw;
    console.log(vm.moduleName, localStorageService.get('state'));
    vm.goHome = function () {
      $state.go('home');
    }

    vm.to =__FEEDBACKEMAIL__;
    vm.appName = localStorageService.get('appName');
    vm.appVersion = localStorageService.get('appVersion');
    vm.visitor = JSON.parse(localStorageService.get('visitor'));
    vm.case = localStorageService.get('case');
    vm.message = encodeURIComponent('Your comments:\n\n\n\n\n\nClient info:\n' + JSON.stringify(vm.deviceInfo));
    vm.subject = encodeURIComponent(vm.appName + ' feedback Version ' + vm.appVersion + ' for case ' + vm.case + ' from \'' + vm.visitor.countryCode + vm.visitor.phoneNumber +'\'');
  } catch(error) {
    Alert.addAlert({ title: 'Error', message: 'Unexpected error: ' + error, type: 'errorAlert', alertClass: 'alert-danger'});
    $anchorScroll();
  }
}